import { Subject } from "rxjs";
import { CustomButton } from "../../rl-common/dialogs/shared/custom-button";
import { ObjFields } from "../../rl-common/shared/shared/types/obj-fields";
import { ObservableArray } from "../../rl-common/shared/shared/types/observable-array";
import { Annotation } from "./annotation";
import { AnnotationConfig } from "./annotation-config";
import { CommentsConfig } from "./comments-config";
import { Type } from "./Tools/annotator-tool";

export type AnnotatorConfigToolsCode = (ObjFields<Type> | 'SHAPE_NO_CMT');
export class AnnotatorConfig {
        
    allowRefresh? : boolean;
    enable? : boolean;
    commentsConfig? : CommentsConfig = new CommentsConfig();    
    canCloseCommentsPanel? : boolean = true;
    fileId? : string;
    toolsDisabled? : ObservableArray<AnnotatorConfigToolsCode> = new ObservableArray([], (arr : any[]) => this.toolsDisabledChanged.next(arr));
    displayPrivatePublicTabs : boolean = false;
    unDrawAnns? = new Subject<AnnotationConfig[]>();
    drawAnns? = new Subject<AnnotationConfig[]>();
    toolsDisabledChanged? = new Subject<AnnotatorConfigToolsCode[]>();

    commentsPanelMessages : string[] = [];
    commentsPanelActions : CustomButton[] = [];

    private _mainAnnotationConfig : AnnotationConfig;
    private _additionalAnnotationConfig : AnnotationConfig[] = [];

    set mainAnnotationConfig(mainAnnEntity : AnnotationConfig){
        if(this._mainAnnotationConfig) this.unDrawAnns.next([this._mainAnnotationConfig]);
        this._mainAnnotationConfig = mainAnnEntity;
        this.drawAnns.next([this._mainAnnotationConfig]);
    }
    get mainAnnotationConfig(){
        return this._mainAnnotationConfig;
    }

    set additionalAnnotationConfig(additionalAnnotationConfig : AnnotationConfig[]){
        if(this._additionalAnnotationConfig.length) this.unDrawAnns.next(this._additionalAnnotationConfig);
        this._additionalAnnotationConfig = additionalAnnotationConfig;
        this.drawAnns.next(this._additionalAnnotationConfig);
    }

    get additionalAnnotationConfig(){
        return this._additionalAnnotationConfig;
    }

    addAnnotationConfig(ac : AnnotationConfig){
        this._additionalAnnotationConfig.push(ac);
        this.drawAnns.next([ac]);
    }

    removeAnnotationConfig(ac : AnnotationConfig){
        let oldAnnsIndex = this._additionalAnnotationConfig.findIndex(a => a.entityType == ac.entityType && a.entityId == ac.entityId);
        this.unDrawAnns.next(this._additionalAnnotationConfig.splice(oldAnnsIndex, 1));
    }

    onNewAnnotation? : (ann : Annotation) => void;
}